import { Component } from '@angular/core'

@Component({
	selector: 'lowgile-chevron',
	template: `
		<div class="chevron-steps">
			<ng-content></ng-content>
		</div>
	`,
	styleUrls: ['./chevron.component.scss'],
})
export class ChevronComponent {}
